import { useEffect, useState } from 'react';
import {
  COMMON_EVENT_NAMES,
  logEvent,
  ModalTypes,
  ProductAreas,
} from 'utils/events';

const logCancelEvent = ({
  modalType,
  openDuration,
  productArea,
}: {
  openDuration?: number;
  modalType: ModalTypes;
  productArea: ProductAreas;
}) => {
  logEvent(COMMON_EVENT_NAMES.MODAL_DISMISSED, {
    modal_type: modalType,
    open_duration: openDuration,
    product_area: productArea,
  });
};

const useModalTracking = ({
  isOpen,
  modalType,
  productArea,
}: {
  isOpen: boolean;
  modalType: ModalTypes;
  productArea: ProductAreas;
}): (() => void) => {
  const [openTime, setOpenTime] = useState<number | null>(null);

  useEffect(() => {
    if (isOpen) {
      setOpenTime(performance.now());
    }
  }, [isOpen]);

  return () => {
    let openDuration;
    if (openTime) {
      openDuration = performance.now() - openTime;
      setOpenTime(null);
    }

    logCancelEvent({ modalType, openDuration, productArea });
  };
};

export default useModalTracking;
